export default __webpack_public_path__ + "static/media/projTrack5.611deaf1.png";